import { parseFormulaAtts } from "src/common/attrEdit/components/formula/common";
import { getEditorInfo } from "src/common/attrEdit/getEditorInfo";
import { getFormulaDependencyIds } from "src/common/formula/getFormulaDependencyIds";
import { replaceFormulaDependencyIds } from "src/common/formula/replaceFormulaDependencyIds";
import { loadFormulaArguments } from "src/pages/ManagementPage/Obj2Tab/forms/AttrForm2/MetaInfo/formula/loadFormulaArguments";
import { AttrDepsHandler } from "../AttrDepsHandler";

/* eslint no-param-reassign: "off" */

export const formulaHandler: AttrDepsHandler = {
  search: (attr, meta) => {
    const editor = getEditorInfo(attr.viewStyles);
    if (
      editor?.component?.editor !== "Formula" &&
      editor?.component?.editor !== "FormulaWithFinancial"
    ) {
      return [];
    }
    const ids = new Set(getFormulaDependencyIds(editor.component.formula));
    // Resolver сравнивает ID строго: сохраняем тип ID исходных атрибутов.
    return meta.attrs
      .filter(({ id }) => ids.has(String(id)))
      .map(({ id }) => id);
  },
  replace: async (attr, meta) => {
    const editor = getEditorInfo(attr.viewStyles);
    if (
      editor?.component?.editor === "Formula" ||
      editor?.component?.editor === "FormulaWithFinancial"
    ) {
      const newFormula = replaceFormulaDependencyIds(
        editor.component.formula,
        meta.attrSrcToDst,
      );
      if (editor.component.formula !== newFormula) {
        editor.component.formula = newFormula;
        editor.component.argumentAtts = parseFormulaAtts(
          newFormula,
          await loadFormulaArguments(meta.dstObjId),
        );
        attr.viewStyles = JSON.stringify(editor);
      }
    }
  },
};
